module.exports = __webpack_public_path__ + "assets/copy-paste-emails.c150e0f0.svg";